<template>
    <div>

        <div class="support-tickets-header">
            <!-- <div class="tickets-control">
                <div class="element-search">
                    <input placeholder="Type to filter products..." type="text">
                </div>
            </div> -->
            <!-- <div class="tickets-filter">
                <div class="form-group mr-3">
                    <label class="d-none d-md-inline-block mr-2">Status</label>
                    <select class="form-control-sm" v-model="selectedStatus" @change="onChange">
                        <option v-for="(status, index) in statusOptions" :value="status" @change="filterProducts()" :selected="index == 0">{{status}}</option>
                    </select>
                </div>

            </div> -->
        </div>
        <div class="support-ticket" v-for="product in sessionProducts" @click="updateProductDetailsContainer(product)">
            <div class="st-meta">
                <i class="fas fa-trash text-danger  " v-if="product.product_deleted_at !== null"></i>
                <!-- <i class="fas fa-check-circle" v-if="isQCApproved(product) == 1" :class="'qc-'+isQCApproved(product)"></i>
                <i class="fas fa-times-circle" v-if="isQCRejected(product) == 1" :class="'qc-'+isQCRejected(product)"></i> -->
            </div>
            <div class="st-body">
                <div class="avatar">
                    <clazy-load :src="formatPreview(product.preview)" class=" incoming-image">
                        <img :src="formatPreview(product.preview)" @error="formatPreview()">
                        <div class="preloader" slot="placeholder">
                            <img src="https://cdn.dribbble.com/users/538630/screenshots/2692720/00-final-anim-icon5.gif">
                        </div>
                    </clazy-load>
                </div>
                <div class="col-sm-4">
                    <div class="ticket-content">
                        <h6 class="ticket-title">
                            {{productDisplayName(product)}}
                        </h6>
                        <div class="ticket-description">
                            {{product.item_identifier}}
                            <br> {{product.brand}}
                            <br>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fas fa-check-circle" v-if="isQCApproved(product) == 1" :class="'qc-approved'+isQCApproved(product)"></i>
                            <i class="fas fa-times-circle" v-if="isQCRejected(product) == 1" :class="'qc-rejected'+isQCRejected(product)"></i>
                        </div>
                        <div class="label pt-1">Status</div>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fas fa-check-circle" v-if="isMove(product) == 1" :class="'qc-'+isMove(product)"></i>
                            <i class="fas fa-times-circle" v-if="isMove(product) == 0" :class="'qc-'+isMove(product)"></i>
                        </div>
                        <div class="label pt-1">Dispatched</div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <table class="table table-v-compact mb-0">
                        <tbody>
                            <tr>
                                <td>
                                    <strong>{{product.qc_action_at}}</strong>
                                    <div class="balance-label smaller lighter text-nowrap">Action On</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="st-foot" v-if="product.is_move == 0">
                <span class="label">Details:</span>
                <span class="value"> {{product.is_move_reason}} </span>
            </div>
            <div class="st-foot">

                <span v-if="product.model_name" class="label">Model:</span>
                <a class="value with-avatar" v-if="product.model_name">
                    <img alt="" :src="'http://52.66.102.131/'+product.model_avatar">
                    <span>{{product.model_name}}</span>
                </a>
                <span class="label">Category:</span>
                <span class="value"> {{product.category_name}} </span>

                <span class="pull-right">
                    <router-link tag="a" :to="`/productdesk/product/${product.id_product}`">
                        View Details
                    </router-link>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Product from '@/mixins/product'
import CommonFunctions from '@/mixins/common-functions'

export default {
  props: ['products'],
  mixins: [Product, CommonFunctions],
  data: function () {
    return {
      statusOptions: ['All Status', 'Approved', 'Rejected', 'Pending'],
      categoryOptions: [],
      selectedStatus: 'All Status',
      sessionProducts: ''
    }
  },
  methods: {
    updateProductDetailsContainer: function (product) {
      this.$emit('productInterface', product)
    },
    isQCApproved: function (product) {
      return product.is_qc_complete == 1 && product.is_qc_approve == 1 ? 1 : 0
    },
    isQCRejected: function (product) {
      return product.is_qc_complete == 1 && product.is_qc_approve == 0 ? 1 : 0
    },
    isMove: function (product) {
      return product.is_move == 1 ? 1 : 0
    },
    isShot: function (product) {
      return product.final_count > 0 ? 1 : 0
    },
    onChange: function () {
      var self = this
      this.filterProducts()
    },
    filterProducts: function () {
      var self = this
      if (self.selectedStatus == 'All Status') {
        self.sessionProducts = self.products
        return true
      }
      const filter = self.products.filter(value => {
        if (self.selectedStatus == 'Pending') {
          return value.is_pretouch_complete == 0
        }
        if (self.selectedStatus == 'Approved') {
          return (
            value.is_pretouch_complete == 1 && value.is_pretouch_approve == 1
          )
        } else {
          return (
            value.is_pretouch_complete == 1 && value.is_pretouch_approve == 0
          )
        }
      })
      self.sessionProducts = filter
    }
  },
  watch: {
    products () {
      this.filterProducts()
    }
  }
}
</script>

<style>
.support-index .support-tickets {
  padding-right: 20px;
  margin-right: 00px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}
.qc-approved1 {
  color: #75da62 !important;
}

.qc-rejected1 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}

.pull-right {
  float: right;
}

.droptext {
  font-weight: bold !important;
  margin-right: 10px;
}
</style>
